// @ts-nocheck

import { type BasketState } from '../../../states/basket';
import { type GenericAction } from '../../../types/redux';

const basketRemoveMultichoiceBetSelection = (state: BasketState, action: GenericAction): BasketState => {
  const { payload } = action;
  const { betId: actionPayloadBetId, matchId: actionPayloadMatchId } = payload ?? {};

  const basketItemsAsArray = Object.keys(state.items).map((itemId) => state.items[itemId]);
  const myMatchBasketItem = basketItemsAsArray.find((item) => item.betbuilder && item.matchId === actionPayloadMatchId);

  if (myMatchBasketItem) {
    const { oddId: myMatchBasketItemId } = myMatchBasketItem;

    if (myMatchBasketItemId) {
      const nextSelectionItems = [
        ...(myMatchBasketItem.selectionItems?.filter(
          (_selectionItem) => _selectionItem.betId !== actionPayloadBetId || !_selectionItem.outcomeIds,
        ) ?? []),
      ];

      if (nextSelectionItems.length) {
        return {
          ...state,
          items: {
            ...state.items,
            [myMatchBasketItemId]: {
              ...myMatchBasketItem,
              selectionItems: nextSelectionItems,
            },
          },
        };
      } else {
        const nextStateItems = { ...state.items };

        delete nextStateItems[`${myMatchBasketItemId}`];

        return {
          ...state,
          items: {
            ...nextStateItems,
          },
        };
      }
    }
  }

  return state;
};

export default basketRemoveMultichoiceBetSelection;
